export enum WEEK {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

export interface ScheduleData {
  entry_time: string;
  exit_time: string;
}

export interface Scale {
  weekday: WEEK;
  schedules: ScheduleData[];
}

export interface ScalePost {
  user_id: string;
  scales: Scale[];
}

export interface ScaleBulkPost {
  user_ids: string[];
  scales: Scale[];
}

export interface ResponseMessage {
  code: string;
  message: string;
  type: string;
}

export interface ResponseStatus {
  id: number;
  name: string;
}

export interface ResponseOk {
  task_id: string;
  status: ResponseStatus;
  messages: ResponseMessage[];
}

export interface ErrorItem {
  [idx: string]: ScheduleError;
}
export interface WorkScheduleModel {
  label: string;
  id: WEEK;
  schedule: ScheduleModel[];
}

export interface ScheduleModel {
  start: string;
  end: string;
}

export interface ScheduleModelFront {
  start: Date;
  end: Date;
}

export interface ScheduleError {
  start: boolean;
  end: boolean;
}

export interface ResponseGetScale {
  scales: Scale[];
  user_id: string;
}